module.exports = __webpack_public_path__ + "static/media/oxygen mall render 04.964faf72.webp";